export default __webpack_public_path__ + "static/media/subhero3.a2ae56ca.jpeg";